import React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../lib/utils";

const cardVariants = cva("group relative overflow-hidden rounded-[24px] kin-surface", {
  variants: {
    variant: {
      default: "",
      interactive:
        "cursor-pointer hover:border-kin-lavender/50 hover:shadow-[0_12px_32px_-8px_rgba(175,82,222,0.15)] active:scale-[0.98] transition-transform duration-200",
      quiet: "border-kin-olive/10 bg-kin-white/60 shadow-sm backdrop-blur-md",
    },
  },
  defaultVariants: {
    variant: "default",
  },
});

const Card = React.forwardRef(({ className, variant, ...props }, ref) => (
  <div className={cn(cardVariants({ variant, className }))} ref={ref} {...props} />
));

Card.displayName = "Card";

const CardHeader = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("flex flex-col gap-1.5 p-6 pb-0", className)} {...props} />
));
CardHeader.displayName = "CardHeader";

const CardTitle = React.forwardRef(({ className, ...props }, ref) => (
  <h3
    ref={ref}
    className={cn("text-lg font-semibold leading-tight tracking-tight text-kin-black", className)}
    {...props}
  />
));
CardTitle.displayName = "CardTitle";

const CardDescription = React.forwardRef(({ className, ...props }, ref) => (
  <p ref={ref} className={cn("text-sm leading-relaxed text-kin-body/85", className)} {...props} />
));
CardDescription.displayName = "CardDescription";

const CardContent = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("p-6 pt-4", className)} {...props} />
));
CardContent.displayName = "CardContent";

const CardFooter = React.forwardRef(({ className, ...props }, ref) => (
  <div ref={ref} className={cn("flex items-center gap-3 p-6 pt-0", className)} {...props} />
));
CardFooter.displayName = "CardFooter";

export { Card, CardHeader, CardTitle, CardDescription, CardContent, CardFooter };
